export const formatFollowers = (count) => {
  if (!count) return "0";
  const formatted = (count / 1000).toFixed(1);
  return `${formatted.endsWith(".0") ? formatted.slice(0, -2) : formatted}K`;
};